var _g, _g2, _defs, _path, _path2, _path3, _path4, _path5, _path6, _defs2, _defs3, _path7, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _g3, _g4, _path8, _path9, _path0, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _defs4, _path1, _path10, _path11, _defs5, _defs6, _defs7, _path12, _path13, _path14, _path15, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateJobGroups({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 750,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9AF38"
    },
    d: "M644.014,334.662c-2.5-37.754,7.472-78.557-11.177-111.656 c-13.215-23.453-38.425-37.879-63.75-47.846c-25.325-9.968-52.176-16.757-75.581-30.531 c-25.226-14.846-45.328-37.182-71.024-51.229c-32.178-17.591-71.476-20.706-107.184-11.875 c-35.709,8.832-67.902,28.979-93.991,54.514c-13.36,13.077-25.321,27.647-40.167,39.072 c-21.274,16.374-48.185,26.095-65.309,46.636c-32.51,38.996-17.584,100.796-44.849,142.922H648.82 C646.299,354.837,644.684,344.78,644.014,334.662z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E85DB"
    },
    d: "M624.487,332.67c-4.705,0-8.785-0.608-12.097-1.395c-9.091-2.16-14.498-6.099-14.552-6.138 c-0.027-0.02-0.044-0.051-0.046-0.084c-0.579-7.815,2.383-15.789,7.924-21.33c0.937-0.938,1.955-1.817,2.94-2.669 c1.312-1.134,2.667-2.305,3.836-3.616c3.489-3.916,5.35-9.165,5.103-14.403c-0.099-2.115-0.536-4.238-0.959-6.291 c-0.511-2.476-1.038-5.036-0.977-7.605c0.095-4.035,1.713-10.26,8.883-16.99c0.842-0.789,1.731-1.566,2.592-2.316 c2.577-2.247,5.242-4.572,6.945-7.559c2.378-4.17,2.621-9.12,2.856-13.906c0.142-2.879,0.287-5.857,0.889-8.677 c1.858-8.723,7.979-15.422,12.786-19.506c9.559-8.12,21.715-13.02,34.231-13.798c0.053,0,0.101,0.03,0.116,0.079 c0.017,0.049-0.003,0.104-0.047,0.132c-5.964,3.904-11.068,9.307-14.373,15.216c-3.63,6.49-4.995,13.332-3.947,19.787 c0.479,2.949,1.459,5.857,2.406,8.671c1.324,3.932,2.693,7.998,2.697,12.203c0.007,7.488-4.204,14.015-8.276,20.327 c-3.602,5.584-7.327,11.358-8.22,17.848c-0.651,4.73,0.259,9.537,1.14,14.186c0.61,3.222,1.241,6.554,1.359,9.862 c0.438,12.319-2.08,19.56-7.697,22.134l0,0C640.384,331.239,631.702,332.67,624.487,332.67z M598.018,324.982 c0.524,0.372,5.813,4.024,14.438,6.071c8.351,1.98,21.626,2.82,37.45-4.433c5.523-2.531,7.997-9.701,7.563-21.917 c-0.117-3.29-0.746-6.613-1.355-9.827c-0.884-4.667-1.798-9.492-1.142-14.26c0.9-6.539,4.64-12.336,8.255-17.941 c4.055-6.284,8.246-12.782,8.239-20.202c-0.003-4.167-1.366-8.215-2.685-12.129c-0.95-2.822-1.934-5.74-2.415-8.707 c-1.057-6.507,0.317-13.401,3.974-19.937c3.255-5.82,8.247-11.153,14.086-15.057c-12.314,0.86-24.254,5.721-33.665,13.715 c-4.779,4.061-10.865,10.72-12.71,19.379c-0.597,2.802-0.743,5.77-0.884,8.64c-0.236,4.813-0.481,9.79-2.887,14.009 c-1.722,3.021-4.402,5.357-6.993,7.618c-0.859,0.749-1.747,1.524-2.585,2.31c-7.112,6.676-8.717,12.836-8.811,16.828 c-0.061,2.542,0.465,5.09,0.972,7.554c0.425,2.061,0.864,4.193,0.965,6.325c0.248,5.299-1.633,10.608-5.162,14.567 c-1.179,1.323-2.54,2.5-3.857,3.638c-0.981,0.849-1.997,1.727-2.929,2.657C600.398,309.367,597.462,317.25,598.018,324.982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E85DB"
    },
    d: "M619.788,332.565c-0.031,0-0.061-0.013-0.085-0.037c-0.043-0.047-0.04-0.119,0.007-0.163 c6.535-6.031,13.315-12.582,18.1-20.49c5.271-8.709,7.26-17.999,5.601-26.157c-0.317-1.561-0.776-3.121-1.219-4.629 c-0.506-1.722-1.029-3.502-1.348-5.3c-1.268-7.158,0.77-14.751,5.454-20.312c1.001-1.189,2.136-2.309,3.233-3.39 c2.079-2.05,4.228-4.17,5.503-6.817c2.456-5.101,1.259-11.021,0.1-16.746c-1.194-5.901-2.429-12.004,0.352-17.204 c0.029-0.057,0.099-0.078,0.156-0.047c0.056,0.03,0.077,0.1,0.047,0.156c-2.742,5.126-1.516,11.188-0.33,17.05 c1.166,5.762,2.371,11.72-0.118,16.891c-1.292,2.684-3.456,4.817-5.549,6.88c-1.093,1.078-2.224,2.193-3.219,3.375 c-4.64,5.509-6.659,13.031-5.403,20.122c0.316,1.787,0.837,3.561,1.342,5.276c0.444,1.512,0.903,3.076,1.223,4.648 c1.672,8.214-0.327,17.563-5.628,26.321c-4.802,7.934-11.595,14.497-18.142,20.541 C619.844,332.555,619.816,332.565,619.788,332.565z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 114.076,
    y: 267.489,
    style: {
      fill: "#2C65B7"
    },
    width: 160.699,
    height: 97.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.489,
    y: 248.383,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 510.5043 121.6531)",
    style: {
      fill: "#3E85DB"
    },
    width: 71.872,
    height: 135.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.684,
    y: 310.738,
    style: {
      fill: "#F9AF38"
    },
    width: 51.484,
    height: 10.681
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9AF38"
    },
    d: "M566.458,343.682c-3.174-1.743-6.657-3.111-9.193-5.695c-3.289-3.352-4.452-8.182-5.597-12.737 c-3.683-14.648-8.549-28.999-14.538-42.865c-5.935-13.743-13.293-27.411-24.97-36.777c-8.188-6.566-18.105-10.672-28.228-13.443 c-19.176-5.249-39.909-5.887-58.793,0.332c-13.797,4.543-26.179,12.541-37.98,21.01c-6.782,4.868-13.527,9.974-21.265,13.105 c-9.066,3.669-19.014,4.436-28.464,6.956c-17.142,4.572-32.621,15.146-43.112,29.453c-7.415,10.112-12.576,22.18-22.287,30.113 c-7.569,6.184-17.153,9.214-25.826,13.719c-7.649,3.973-15.115,9.875-17.935,17.814h356.402 C581.278,355.849,574.75,348.235,566.458,343.682z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C65B7"
    },
    d: "M76.835,364.669c25.21,7.786,42.809,33.425,67.485,44.554c21.698,9.786,46.629,7.454,70.393,6.089 c74.109-4.258,148.421,2.811,221.963,12.907c24.865,3.413,51.188,6.996,74.252-2.902c17.895-7.68,31.649-22.646,48.7-32.054 c23.458-12.943,51.369-14.51,76.75-23.088c2.904-0.981,5.941-2.175,7.774-4.632c0.203-0.273,0.379-0.568,0.535-0.875H76.835z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EFE5DA"
    },
    points: "613.514,123.007 588.837,123.007 585.176,76.749 617.176,76.749  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9AF38"
    },
    d: "M611.549,97.141l-1.731,21.866h-17.284l-1.716-21.668c0,0,3.527,2.555,8.43,2.539 C604.151,99.862,605.497,96.809,611.549,97.141z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -12.835 143.1953)",
    style: {
      fill: "#F9AF38"
    },
    cx: 166.435,
    cy: 87.091,
    rx: 43.33,
    ry: 43.33
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -12.835 143.1953)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 166.435,
    cy: 87.091,
    rx: 34.792,
    ry: 34.792
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3E85DB"
    },
    points: "166.434,84.591 190.417,87.091 166.434,89.591  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3E85DB"
    },
    points: "163.934,87.091 166.434,67.854 168.934,87.091  "
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2C65B7"
    },
    cx: 166.434,
    cy: 87.091,
    r: 3.803
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M166.435,60.973c-0.064,0-0.115-0.052-0.115-0.115v-5.715c0-0.063,0.052-0.115,0.115-0.115 c0.063,0,0.115,0.052,0.115,0.115v5.715C166.55,60.921,166.498,60.973,166.435,60.973z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.435,119.155c-0.064,0-0.115-0.052-0.115-0.115v-5.715c0-0.064,0.052-0.115,0.115-0.115 c0.063,0,0.115,0.052,0.115,0.115v5.715C166.55,119.103,166.498,119.155,166.435,119.155z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.383,87.206h-5.715c-0.064,0-0.115-0.052-0.115-0.115s0.052-0.115,0.115-0.115h5.715 c0.063,0,0.115,0.052,0.115,0.115S198.447,87.206,198.383,87.206z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.201,87.206h-5.715c-0.063,0-0.115-0.052-0.115-0.115s0.052-0.115,0.115-0.115h5.715 c0.063,0,0.115,0.052,0.115,0.115S140.265,87.206,140.201,87.206z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.984,68.656c-0.029,0-0.059-0.011-0.082-0.034c-0.045-0.045-0.045-0.118,0-0.163l4.041-4.041 c0.045-0.045,0.118-0.045,0.163,0c0.045,0.045,0.045,0.118,0,0.163l-4.041,4.041C185.043,68.645,185.014,68.656,184.984,68.656z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.843,109.797c-0.029,0-0.059-0.011-0.082-0.034c-0.045-0.045-0.045-0.118,0-0.163l4.042-4.042 c0.045-0.045,0.118-0.045,0.163,0c0.045,0.045,0.045,0.118,0,0.163l-4.042,4.042 C143.902,109.786,143.873,109.797,143.843,109.797z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.025,109.797c-0.029,0-0.059-0.011-0.082-0.034l-4.041-4.042c-0.045-0.045-0.045-0.118,0-0.163 c0.045-0.045,0.118-0.045,0.163,0l4.041,4.042c0.045,0.045,0.045,0.118,0,0.163 C189.084,109.786,189.055,109.797,189.025,109.797z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.885,68.656c-0.029,0-0.059-0.011-0.082-0.034l-4.042-4.041c-0.045-0.045-0.045-0.118,0-0.163 c0.045-0.045,0.118-0.045,0.163,0l4.042,4.041c0.045,0.045,0.045,0.118,0,0.163C147.944,68.645,147.914,68.656,147.885,68.656z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#75421C"
    },
    d: "M308.8,198.781c0.848-2.756,1.383-6.162,1.429-10.371c0,0,5.51-1.141,5.604-8.482 c0.094-7.34-24.286-16.243-33.349-8.145c0,0-5.008-0.481-7.397,4.77c-1.772,3.896-4.036,11.809-1.277,21.793 c3.334,12.069-3.898,16.227-3.898,16.227c9.29,9.324,30.086,11.382,40.63,1.476c0,0-5.535-12.215-0.718-27.658"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD19F"
    },
    d: "M324.083,240.082c0,0-3.719-10.49-6.527-15.93c-2.806-5.44-9.333-7.247-11.759-7.963 c-2.465-0.728-4.057,4.59,1.758,13.948c5.774,9.291,11.29,22.745,16.698,21.997c5.406-0.748,18.377-20.954,20.371-24.859 c0,0,6.016,0.319,10.905-3.978c4.566-4.014,7.498-7.176,5.553-9.678c-1.188-1.531-11.108-0.204-15.181,4.104 c0,0,0.895-5.83-0.688-6.715c-1.583-0.886-4.783,8.579-4.646,13.708C340.567,224.716,327.622,233.813,324.083,240.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFAC35"
    },
    d: "M329.475,233.74c-2.261,2.148-4.286,4.383-5.392,6.342c0,0-3.719-10.49-6.527-15.93 c-2.806-5.44-9.333-7.247-11.759-7.963c-2.465-0.728-4.057,4.59,1.758,13.948c5.774,9.291,11.29,22.745,16.698,21.997 c2.865-0.396,7.854-6.258,12.209-12.261C332.367,239.044,330.41,236.262,329.475,233.74z"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M351.398,217.487c-0.039,0-0.077-0.021-0.096-0.059c-0.027-0.053-0.006-0.118,0.047-0.145 c1.994-1.008,5.255-2.357,9.184-3.797l0.12-0.044c0.056-0.02,0.117,0.008,0.138,0.064c0.021,0.056-0.008,0.117-0.064,0.138 l-0.12,0.044c-3.921,1.438-7.174,2.783-9.161,3.787C351.431,217.483,351.414,217.487,351.398,217.487z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.366,219.407c-0.04,0-0.078-0.022-0.097-0.06c-0.026-0.053-0.004-0.118,0.049-0.144 c0.061-0.03,6.09-2.969,9.217-4.27c0.054-0.022,0.118,0.003,0.141,0.058c0.023,0.055-0.003,0.118-0.058,0.141 c-3.121,1.299-9.145,4.235-9.205,4.265C352.398,219.404,352.382,219.407,352.366,219.407z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.047,221.254c-0.042,0-0.081-0.024-0.099-0.065c-0.023-0.055,0.001-0.118,0.056-0.141 c0.411-0.178,1.233-0.619,2.103-1.085c0.796-0.427,1.619-0.869,2.181-1.137c0.611-0.292,3.935-2.126,3.969-2.145 c0.052-0.029,0.117-0.01,0.146,0.042c0.029,0.052,0.01,0.117-0.042,0.146c-0.137,0.076-3.364,1.856-3.98,2.15 c-0.558,0.266-1.379,0.707-2.173,1.132c-0.874,0.469-1.699,0.912-2.119,1.093C353.076,221.251,353.061,221.254,353.047,221.254 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.173,221.749c-0.047,0-0.091-0.032-0.104-0.08c-0.423-1.578-1.083-3.054-1.963-4.389 c-0.033-0.05-0.019-0.116,0.031-0.149c0.05-0.033,0.117-0.019,0.149,0.031c0.892,1.354,1.562,2.851,1.991,4.451 c0.015,0.057-0.019,0.116-0.076,0.132C353.192,221.748,353.182,221.749,353.173,221.749z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFE5DA"
    },
    d: "M331.766,231.657c-1.04,0.91-2.077,1.86-3.052,2.82c0.251-0.246,0.504-0.492,0.762-0.737 c0.935,2.523,2.891,5.304,6.986,6.133c0.704-0.971,1.39-1.944,2.049-2.9C334.817,236.052,332.776,233.458,331.766,231.657z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44413D"
    },
    d: "M305.997,360.581c0,0,11.033-78.031,2.714-103.826c-12.655,2.668-25.315,1.048-31.37-0.058 c-2.508,5.043-4.991,12.618-5.174,23.016c-0.378,21.427,2.341,82.152,2.341,82.152s-16.279,7.008-17.736,13.456 c-1.458,6.451,23.752-2.971,27.116-6.458c0,0,0.367-2.007,0.886-5.32c1.73-11.043,5.153-36.614,2.336-50.866l4.715-37.623 l4.588,37.189c0,0-7.25,9.607,1.19,50.571c0.477,2.314,1.003,4.728,1.585,7.247c0,0,23.23,12.615,25.115,7.699 C326.186,372.844,305.997,360.581,305.997,360.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFAC35"
    },
    d: "M309.646,260.208c-1.138-5.024-2.788-8.726-5.093-10.483c0,0,9.436-24.811,6.56-30.278 c-0.511-0.975-1.589-1.753-2.96-2.374c-4.938-2.236-13.693-2.438-13.693-2.438s-14.577-0.796-17.143,3.284 c-2.696,4.29,5.371,30.927,5.371,30.927s-3.592,3.343-6.581,10.564C281.124,261.938,295.318,267.65,309.646,260.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFAC35"
    },
    d: "M308.711,256.755c-12.655,2.668-25.315,1.048-31.37-0.058c-2.508,5.043-4.991,12.618-5.174,23.016 c-0.077,4.345-0.026,10.307,0.104,17.051c3.788,0.89,9.561,1.918,16.565,2.135c1.891,0.058,3.871,0.056,5.927-0.023 c5.233-0.202,10.947-0.915,16.905-2.445C312.139,280.566,311.561,265.594,308.711,256.755z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B24F69"
    },
    d: "M266.402,367.138c-0.289-0.196-0.589-0.376-0.896-0.547c-4.034,2.501-8.045,5.677-8.735,8.73 c-1.458,6.451,23.752-2.971,27.116-6.458c0,0,0.206-1.124,0.526-3.078c-4.607,1.737-9.215,3.474-13.822,5.211 C269.302,369.598,267.976,368.207,266.402,367.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B24F69"
    },
    d: "M316.72,367.997c-2.333,0.509-4.52,1.708-6.107,3.495c-4.049-2.689-8.298-5.07-12.687-7.16 c0.392,1.853,0.805,3.75,1.262,5.729c0,0,23.23,12.615,25.115,7.699C325.188,375.45,321.198,371.517,316.72,367.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFE5DA"
    },
    d: "M289.464,223.459c3.833,4.285,6.006-5.553,6.006-5.553s0.065,6.387,3.986,6.634 c3.447,0.217,4.104-5.399,3.368-9.016c-4.203-0.792-8.363-0.888-8.363-0.888s-2.984-0.162-6.487,0.037 C287.404,216.291,286.516,220.164,289.464,223.459z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_76_",
    d: "M299.929,210.227c0,0,8.36-0.57,10.499-8.222c2.327-8.315,2.209-20.966-3.76-26.478 c-5.965-5.512-26.68-6.724-29.044,8.38c-2.143,13.666,3.059,22.362,12.624,26.508v6.276c0,0,3.696,5.34,9.755,0.739 L299.929,210.227z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_76_",
    style: {
      overflow: "visible",
      fill: "#FFD19F"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000003806466994079138420000003333412673129109896_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_76_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000003806466994079138420000003333412673129109896_)",
      fill: "#F9B693"
    },
    d: "M287,199.989 c0,2.637,2.138,4.776,4.775,4.776c2.637,0,4.776-2.138,4.776-4.776s-2.138-4.775-4.776-4.775 C289.138,195.213,287,197.351,287,199.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000003806466994079138420000003333412673129109896_)",
      fill: "#F9B693"
    },
    d: "M305.349,199.512 c0,2.638,2.138,4.776,4.776,4.776c2.637,0,4.776-2.138,4.776-4.776c0-2.637-2.138-4.775-4.776-4.775 C307.487,194.736,305.349,196.875,305.349,199.512z"
  })), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.785,201.149c-0.034,0-0.068-0.016-0.088-0.046c-0.034-0.049-0.022-0.116,0.027-0.15 c0.129-0.09,0.25-0.285,0.357-0.457c0.042-0.067,0.081-0.131,0.119-0.185c0.24-0.343,0.659-1.113,0.522-1.572 c-0.032-0.085-0.412-0.262-0.574-0.337c-0.115-0.053-0.206-0.096-0.255-0.129c-0.497-0.337-1.186-0.888-1.653-1.598 c-0.822-1.244-1.236-2.976-1.135-4.751c0.112-1.993,1.047-3.981,2.439-5.188c1.027-0.889,2.247-1.301,3.524-1.19 c0.572,0.05,1.183,0.146,1.77,0.51c0.05,0.031,0.066,0.098,0.035,0.148c-0.031,0.05-0.098,0.066-0.148,0.035 c-0.518-0.321-1.044-0.424-1.675-0.479c-1.219-0.106-2.383,0.288-3.365,1.138c-1.35,1.17-2.257,3.1-2.365,5.037 c-0.098,1.73,0.303,3.414,1.1,4.621c0.447,0.68,1.114,1.212,1.594,1.538c0.035,0.023,0.127,0.066,0.225,0.112 c0.372,0.173,0.639,0.308,0.689,0.47c0.16,0.538-0.271,1.358-0.551,1.757c-0.035,0.051-0.073,0.112-0.112,0.175 c-0.118,0.19-0.251,0.405-0.416,0.52C303.827,201.143,303.806,201.149,303.785,201.149z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M298.227,187.586c-0.028,0-0.057-0.011-0.078-0.033c-1.71-1.786-4.117-2.414-6.439-1.682 c-0.541,0.171-0.936,0.495-1.354,0.838c-0.229,0.188-0.465,0.381-0.727,0.548c-0.05,0.032-0.117,0.017-0.148-0.033 c-0.032-0.05-0.017-0.117,0.033-0.148c0.251-0.16,0.482-0.349,0.706-0.533c0.416-0.341,0.846-0.694,1.426-0.877 c2.401-0.758,4.891-0.108,6.659,1.738c0.041,0.043,0.04,0.111-0.003,0.152C298.28,187.576,298.253,187.586,298.227,187.586z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M299.324,204.728c-0.813,0-1.932-0.303-2.625-0.984c-0.042-0.042-0.043-0.11-0.001-0.152 c0.042-0.042,0.11-0.043,0.152-0.001c0.554,0.545,1.568,0.923,2.472,0.923c0.008,0,0.017-0.001,0.025,0 c0.059,0,0.107,0.048,0.107,0.107c0,0.059-0.047,0.108-0.107,0.108C299.341,204.728,299.332,204.728,299.324,204.728z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M300.436,203.313c-0.549,0-1.097-0.084-1.614-0.254c-1.144-0.375-2.163-1.176-2.798-2.199 c-0.031-0.05-0.016-0.117,0.035-0.148c0.05-0.031,0.117-0.016,0.148,0.035c0.608,0.98,1.586,1.748,2.682,2.107 c1.096,0.359,2.339,0.319,3.409-0.111c0.055-0.022,0.118,0.005,0.14,0.06c0.022,0.055-0.005,0.118-0.06,0.14 C301.767,203.189,301.101,203.313,300.436,203.313z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M296.015,190.585c-0.047,0-0.09-0.031-0.103-0.078c-0.016-0.057,0.017-0.117,0.074-0.133 c1.053-0.302,0.994-1.732,0.993-1.746c-0.003-0.059,0.043-0.11,0.102-0.113c0.057-0.002,0.11,0.043,0.113,0.102 c0.001,0.016,0.069,1.615-1.149,1.964C296.035,190.584,296.025,190.585,296.015,190.585z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M308.646,190.359c-0.047,0-0.09-0.031-0.103-0.078c-0.016-0.057,0.017-0.117,0.074-0.133 c1.053-0.302,0.994-1.732,0.993-1.746c-0.003-0.059,0.043-0.11,0.102-0.113c0.056-0.001,0.11,0.043,0.113,0.102 c0.001,0.016,0.069,1.615-1.149,1.964C308.666,190.358,308.656,190.359,308.646,190.359z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_75_",
    d: "M290.647,194.049c-0.942-2.299-0.161-4.741,1.746-5.456c1.905-0.714,4.216,0.57,5.158,2.869 c0.942,2.299,0.161,4.741-1.746,5.456C293.899,197.633,291.589,196.348,290.647,194.049z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_75_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000137822389924607272580000017186718256780437134_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_75_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000137822389924607272580000017186718256780437134_)",
      fill: "#A4AF54"
    },
    d: "M292.821,193.451 c0.038,2.043,1.515,3.672,3.299,3.64c1.784-0.033,3.201-1.716,3.163-3.759s-1.515-3.672-3.299-3.64 C294.2,189.725,292.783,191.408,292.821,193.451z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_74_",
    d: "M309.69,192.523c0.245-2.471-1.11-4.598-3.024-4.752c-1.915-0.154-3.665,1.724-3.908,4.195 c-0.245,2.47,1.109,4.598,3.024,4.752C307.697,196.871,309.447,194.993,309.69,192.523z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_74_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000119095978116513147030000008719082210962023582_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_74_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000119095978116513147030000008719082210962023582_)",
      fill: "#A4AF54"
    },
    d: "M304.349,193.354 c0.038,2.043,1.515,3.673,3.299,3.64c1.784-0.033,3.201-1.716,3.163-3.759c-0.038-2.043-1.515-3.673-3.299-3.64 C305.727,189.628,304.311,191.311,304.349,193.354z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M284.683,198.7c-0.059,0-0.107-0.048-0.107-0.107c0-2.294-1.389-5.443-3.456-6.475 c-0.053-0.026-0.075-0.091-0.048-0.144c0.026-0.053,0.091-0.075,0.144-0.048c2.138,1.067,3.575,4.309,3.575,6.667 C284.79,198.652,284.742,198.7,284.683,198.7z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#75421C"
    },
    d: "M305.456,174.249c-7.214-4.84-26.088-5.369-28.359,9.142c-2.179,13.894,2.248,23.375,13.15,27.025 l-6.41-7.786c-6.174-2.026-6.773-11.836-3.454-12.852c3.315-1.016,5.207,3.87,5.207,3.87c8.419-3.713,13.525-8.997,16.464-13.161 c2.357,2.155,6.052,4.982,9.998,5.844C312.052,186.331,313.198,178.848,305.456,174.249z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.819,
    y: 230.443,
    transform: "matrix(0.385 0.9229 -0.9229 0.385 407.4925 -58.9551)",
    style: {
      fill: "#EFE5DA"
    },
    width: 74.332,
    height: 91.703
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.18,
    y: 224.816,
    transform: "matrix(0.1388 0.9903 -0.9903 0.1388 481.9167 -12.8483)",
    style: {
      fill: "#FFFFFF"
    },
    width: 74.332,
    height: 91.703
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.428,
    y: 257.806,
    transform: "matrix(0.1388 0.9903 -0.9903 0.1388 504.317 -47.3022)",
    style: {
      fill: "#E5D8CA"
    },
    width: 61.856,
    height: 17.028
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "263.758,299.736 255.172,238.48 255.399,238.448 263.986,299.705  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "258.498,300.474 249.911,239.218 250.138,239.186 258.725,300.442  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "253.236,301.212 244.649,239.955 244.877,239.923 253.464,301.181  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "247.975,301.949 239.388,240.693 239.616,240.661 248.203,301.918  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "242.714,302.686 234.127,241.43 234.355,241.398 242.942,302.655  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "237.453,303.424 228.866,242.167 229.094,242.135 237.681,303.393  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "222.219,305.56 213.632,244.303 213.86,244.271 222.447,305.528  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "216.958,306.297 208.372,245.04 208.599,245.008 217.186,306.266  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD19F"
    },
    d: "M271.22,216.3c-10.653,2.487-23.783,8.44-25.451,13.637c-1.67,5.196-1.632,17.124,0.958,29.482 c0,0-2.897,5.283-1.145,11.551c1.635,5.856,4.165,9.027,7.263,8.361c1.895-0.408,2.488-7.824,0.372-13.36 c0,0,2.784,6.076,4.013,3.947c1.215-2.109-0.176-7.917-4.684-11.381c0,0,3.035-15.751,1.25-24.727c0,0,11.02-2.109,16.966-3.561 c6.917-1.688,11.368-2.615,14.028-4.98l2.629-10.563C287.419,214.706,276.673,215.027,271.22,216.3z"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M249.371,278.441c-0.01-0.008-0.019-0.018-0.026-0.03c-0.449-0.768-0.637-1.795-0.803-2.701 c-0.045-0.246-0.089-0.485-0.136-0.711c-0.473-2.253-0.779-6.787-0.782-6.832c-0.004-0.059,0.041-0.111,0.1-0.114 c0.059-0.004,0.11,0.041,0.114,0.1c0.003,0.045,0.308,4.565,0.778,6.802c0.048,0.228,0.092,0.468,0.137,0.716 c0.163,0.889,0.348,1.896,0.777,2.631c0.03,0.051,0.013,0.117-0.038,0.147C249.453,278.473,249.405,278.468,249.371,278.441z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.33,279.413c-0.017-0.013-0.03-0.032-0.036-0.054c-0.007-0.024-0.684-2.385-0.886-3.146 c-0.488-1.833-0.8-3.805-0.98-6.203c-0.058-0.73-0.077-1.46-0.087-2.013c-0.001-0.059,0.046-0.108,0.105-0.109 c0.059-0.001,0.108,0.046,0.109,0.106c0.01,0.551,0.029,1.276,0.086,2.001c0.18,2.386,0.489,4.344,0.974,6.164 c0.201,0.76,0.878,3.118,0.885,3.142c0.016,0.057-0.017,0.117-0.074,0.133C251.393,279.443,251.357,279.434,251.33,279.413z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.189,279.213c-0.016-0.013-0.029-0.031-0.036-0.053c-0.852-2.84-1.346-5.75-1.428-8.418 c-0.019-0.661-0.04-1.308-0.082-1.95c-0.004-0.068-0.014-0.147-0.023-0.232c-0.028-0.248-0.061-0.529-0.007-0.732 c0.015-0.057,0.074-0.092,0.131-0.077c0.057,0.015,0.092,0.074,0.077,0.131c-0.043,0.164-0.012,0.435,0.013,0.653 c0.01,0.089,0.02,0.172,0.024,0.243c0.042,0.645,0.063,1.294,0.082,1.957c0.081,2.649,0.572,5.54,1.419,8.362 c0.017,0.057-0.015,0.117-0.072,0.134C253.252,279.243,253.216,279.235,253.189,279.213z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFAC35"
    },
    d: "M287.419,214.706c0,0-10.746,0.32-16.199,1.594c-10.653,2.487-23.783,8.44-25.451,13.637 c-1.122,3.49-1.468,10.023-0.793,17.678c3.748-1.802,7.09-1.148,9.084-0.391c0.382-4.54,0.497-9.59-0.264-13.414 c0,0,11.02-2.109,16.966-3.561c6.917-1.689,11.368-2.615,14.028-4.98c1.961-1.743,2.166-5.231,2.324-7.749 C287.2,216.14,287.858,215.027,287.419,214.706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFE5DA"
    },
    d: "M244.976,247.616c-0.078-0.883-0.141-1.749-0.192-2.6c0.111,1.851,0.283,3.783,0.524,5.774 c3.313-1.603,6.323-1.133,8.432-0.331c0.117-1.03,0.226-2.118,0.32-3.235C252.066,246.467,248.724,245.814,244.976,247.616z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 432.831,
    y: 123.007,
    style: {
      fill: "#2C65B7"
    },
    width: 203.193,
    height: 241.662
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.988,
    y: 98.85,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 718.8732 -349.9812)",
    style: {
      fill: "#3E85DB"
    },
    width: 90.877,
    height: 171.192
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.807,
    y: 213.168,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 833.1915 -235.6629)",
    style: {
      fill: "#205DA5"
    },
    width: 101.241,
    height: 171.192
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.879,
    y: 177.693,
    style: {
      fill: "#F9AF38"
    },
    width: 65.098,
    height: 13.506
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.604,
    y: 213.168,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 715.9885 -118.4599)",
    style: {
      fill: "#3E85DB"
    },
    width: 101.241,
    height: 171.192
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.676,
    y: 292.012,
    style: {
      fill: "#F9AF38"
    },
    width: 65.098,
    height: 13.506
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 403.698,
    y: 174.779,
    style: {
      fill: "#E5D8CA"
    },
    width: 89.65,
    height: 73.44
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.06,
    y: 161.081,
    style: {
      fill: "#EFE5DA"
    },
    width: 100.874,
    height: 87.138
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 347.037,
    y: 154.715,
    style: {
      fill: "#FFFFFF"
    },
    width: 110.483,
    height: 93.505
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 394.083,
    y: 172.127,
    width: 54.748,
    height: 0.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.083,
    y: 180.48,
    width: 54.748,
    height: 0.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.083,
    y: 188.831,
    width: 54.748,
    height: 0.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.083,
    y: 197.184,
    width: 54.748,
    height: 0.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.458,
    y: 218.718,
    width: 92.373,
    height: 0.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.458,
    y: 225.659,
    width: 92.373,
    height: 0.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.458,
    y: 232.6,
    width: 92.373,
    height: 0.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.458,
    y: 239.54,
    width: 92.373,
    height: 0.23
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 356.458,
    y: 163.065,
    style: {
      fill: "#EFE5DA"
    },
    width: 32.136,
    height: 43.411
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E85DB"
    },
    d: "M196.838,186.04c-5.965-4.327-13.12-6.847-18.902-11.416 c-8.209-6.488-13.092-16.666-21.853-22.388c-5.181-3.383-11.324-4.934-17.391-6.148c-6.157-1.232-12.508-2.176-18.694-1.099 c-17.115,2.978-28.087,20.05-43.966,27.096c-4.162,1.847-8.666,3.001-12.491,5.472c-6.179,3.991-9.7,10.765-12.539,17.676 h153.674C202.996,191.629,200.079,188.39,196.838,186.04z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E85DB"
    },
    d: "M525.681,95.003c-5.229-5.871-12.126-10.104-17.15-16.151 c-8.592-10.34-11.108-25.229-21.36-33.925c-4.33-3.673-9.735-5.912-15.276-7.157c-6.737-1.513-13.872-1.607-20.486,0.379 c-18.07,5.427-28.822,24.764-46.334,31.787c-8.365,3.355-17.748,3.656-25.984,7.317c-5.485,2.438-10.308,6.346-13.83,11.206 c-3.954,5.456-6.483,12.247-10.44,17.54h176.813C530.668,101.992,528.433,98.093,525.681,95.003z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E85DB"
    },
    d: "M119.718,350.884c-2.055-2.301-4.497-4.246-6.417-6.661c-3.269-4.111-4.851-9.525-4.311-14.75 c0.482-4.658,2.56-9.077,2.713-13.757c0.213-6.53-3.379-12.647-7.884-17.379c-3.178-3.338-6.932-6.296-8.987-10.422 c-3.433-6.895-1.302-15.18-2.482-22.792c-1.209-7.799-5.919-14.688-11.637-20.127c-9.051-8.609-20.932-14.193-33.337-15.667 c11.246,8.299,19.381,22.445,16.371,36.094c-1.547,7.014-5.855,13.365-6.264,20.536c-0.8,14.007,13.198,25.041,14.328,39.025 c0.652,8.068-3.104,15.828-3.845,23.889c-0.494,5.368,0.42,10.846,2.549,15.797h55.732 C125.404,359.586,123.153,354.729,119.718,350.884z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.913,364.785c-0.036,0-0.07-0.017-0.093-0.048c-1.857-2.55-3.401-4.998-4.72-7.484 c-4.801-9.042-6.272-18.487-4.143-26.596c0.407-1.551,0.954-3.087,1.483-4.572c0.6-1.685,1.22-3.427,1.636-5.191 c1.652-7.011,0.058-14.635-4.265-20.395c-0.927-1.234-1.993-2.411-3.023-3.548c-1.974-2.179-4.016-4.431-5.155-7.184 c-2.195-5.302-0.657-11.183,0.83-16.87c1.513-5.786,3.078-11.77,0.628-17.041c-0.026-0.058-0.001-0.126,0.056-0.153 c0.059-0.025,0.126-0.002,0.153,0.056c2.484,5.348,0.909,11.371-0.614,17.196c-1.478,5.651-3.005,11.494-0.84,16.725 c1.124,2.716,3.152,4.953,5.113,7.117c1.034,1.141,2.104,2.321,3.036,3.564c4.363,5.814,5.973,13.51,4.305,20.586 c-0.419,1.777-1.041,3.525-1.643,5.216c-0.527,1.48-1.072,3.012-1.477,4.554c-2.115,8.052-0.65,17.439,4.123,26.43 c1.314,2.476,2.853,4.915,4.703,7.457c0.038,0.051,0.026,0.123-0.025,0.16C91.96,364.777,91.936,364.785,91.913,364.785z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9AF38"
    },
    d: "M163.04,359.346c-3.541-6.926-9.761-13.465-8.63-21.161c0.728-4.955,4.409-8.884,6.628-13.373 c3.27-6.613,3.228-14.766-0.11-21.345c-3.086-6.081-8.84-11.045-9.688-17.811c-1.068-8.518,5.989-15.702,8.68-23.855 c1.907-5.776,1.534-12.271-1.021-17.79c-2.826-6.106-8.026-10.741-11.896-16.245c-3.87-5.504-6.366-13.007-3.058-18.867 c-10.487,2.97-21.498,8.172-25.902,18.142c-2.993,6.775-2.222,15.076,1.968,21.183c1.98,2.887,4.659,5.307,6.206,8.447 c3.771,7.65-0.252,16.825-5.235,23.747c-2.277,3.164-4.851,6.366-5.433,10.22c-0.831,5.503,2.563,10.627,4.466,15.857 c2.783,7.648,2.34,16.413-1.2,23.741c-2.413,4.995-6.145,9.256-8.623,14.219c-3.099,6.206-3.89,13.403-2.629,20.216h57.616 C164.626,362.836,163.912,361.052,163.04,359.346z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.234,364.784c-0.041,0-0.081-0.023-0.102-0.062c-0.696-1.304-1.464-2.6-2.206-3.853 c-1.2-2.023-2.44-4.116-3.413-6.304c-3.524-7.931-3.248-17.174,0.719-24.122c1.164-2.039,2.665-3.977,4.117-5.85 c3.026-3.905,5.884-7.595,6.133-12.269c0.24-4.493-2.03-8.356-4.433-12.447c-1.964-3.343-3.994-6.8-4.491-10.606 c-0.781-5.986,2.249-11.571,5.179-16.973c0.252-0.463,0.502-0.925,0.748-1.384c2.734-5.091,5.65-11.739,3.923-18.009 c-0.921-3.343-3.067-6.209-5.143-8.981c-0.443-0.591-0.885-1.181-1.314-1.775c-2.071-2.861-4.759-7.188-4.194-11.714 c0.008-0.062,0.065-0.105,0.129-0.1c0.063,0.008,0.108,0.066,0.1,0.128c-0.555,4.446,2.104,8.721,4.152,11.551 c0.429,0.592,0.87,1.182,1.312,1.772c2.088,2.789,4.248,5.673,5.18,9.058c1.749,6.348-1.188,13.049-3.942,18.179 c-0.247,0.459-0.497,0.921-0.749,1.384c-2.913,5.369-5.925,10.921-5.153,16.834c0.49,3.76,2.508,7.196,4.461,10.519 c2.314,3.94,4.707,8.015,4.464,12.576c-0.253,4.746-3.266,8.636-6.18,12.397c-1.447,1.868-2.943,3.799-4.099,5.823 c-3.931,6.887-4.203,16.051-0.709,23.915c0.967,2.176,2.204,4.263,3.4,6.28c0.744,1.255,1.514,2.553,2.212,3.862 c0.03,0.056,0.009,0.125-0.047,0.155C137.271,364.779,137.252,364.784,137.234,364.784z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9AF38"
    },
    d: "M702.624,253.611c-12.453-0.989-25.199,2.155-35.763,8.82 c-6.675,4.211-12.645,10.042-15.361,17.453c-2.651,7.232-2.187,15.774-6.906,21.862c-2.824,3.642-7.086,5.806-10.857,8.456 c-5.346,3.756-10.069,9.049-11.141,15.494c-0.769,4.619,0.403,9.361-0.039,14.022c-0.496,5.229-3.11,10.227-7.122,13.617 c-2.357,1.991-5.133,3.42-7.599,5.272c-2.255,1.693-4.219,3.755-5.839,6.062h57.134c0.35-7.386-1.264-14.956,0.764-22.057 c3.852-13.49,19.743-21.564,21.707-35.455c1.006-7.111-1.972-14.184-2.112-21.365 C679.215,271.817,689.968,259.542,702.624,253.611z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M642.955,364.784c-0.02,0-0.039-0.005-0.057-0.016c-0.056-0.031-0.075-0.101-0.043-0.156 c3.476-6.137,5.123-12.572,4.765-18.61c-0.094-1.591-0.328-3.199-0.555-4.754c-0.258-1.776-0.525-3.612-0.588-5.438 c-0.246-7.266,2.843-14.495,8.263-19.341c1.158-1.035,2.438-1.983,3.676-2.898c2.348-1.737,4.775-3.533,6.41-5.976 c3.15-4.704,2.799-10.733,2.459-16.564c-0.351-6.011-0.714-12.227,2.771-16.982c0.037-0.051,0.109-0.061,0.161-0.025 c0.051,0.037,0.062,0.109,0.024,0.161c-3.436,4.688-3.076,10.862-2.728,16.832c0.342,5.869,0.696,11.938-2.497,16.707 c-1.657,2.475-4.102,4.283-6.465,6.031c-1.233,0.913-2.509,1.857-3.66,2.886c-5.369,4.8-8.429,11.963-8.185,19.161 c0.061,1.813,0.328,3.644,0.585,5.413c0.227,1.56,0.462,3.173,0.558,4.773c0.36,6.083-1.298,12.561-4.796,18.737 C643.034,364.763,642.995,364.784,642.955,364.784z"
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9AF38"
    },
    cx: 324.979,
    cy: 135.669,
    r: 8.849
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E85DB"
    },
    d: "M286.267,121.998c-3.874,0-7.026-3.152-7.026-7.026c0-3.874,3.152-7.026,7.026-7.026 c3.874,0,7.026,3.152,7.026,7.026C293.293,118.846,290.141,121.998,286.267,121.998z M286.267,108.177 c-3.747,0-6.795,3.048-6.795,6.795c0,3.748,3.048,6.796,6.795,6.796s6.795-3.048,6.795-6.796 C293.062,111.225,290.014,108.177,286.267,108.177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C65B7"
    },
    d: "M190.417,234.167c-3.874,0-7.026-3.152-7.026-7.026c0-3.874,3.152-7.026,7.026-7.026 c3.874,0,7.026,3.152,7.026,7.026C197.443,231.015,194.291,234.167,190.417,234.167z M190.417,220.346 c-3.748,0-6.796,3.048-6.796,6.795c0,3.748,3.048,6.796,6.796,6.796c3.747,0,6.795-3.048,6.795-6.796 C197.212,223.394,194.164,220.346,190.417,220.346z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#2C65B7"
    },
    cx: 185.7,
    cy: 380.736,
    rx: 22.785,
    ry: 5.775
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C65B7"
    },
    d: "M244.784,396.152c0,2.435-5.511,4.409-12.308,4.409s-12.308-1.974-12.308-4.409 c0-2.435,5.511-4.409,12.308-4.409S244.784,393.718,244.784,396.152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C65B7"
    },
    d: "M384.512,377.421c0,2.738-6.262,4.958-13.987,4.958c-7.725,0-13.987-2.22-13.987-4.958 c0-2.739,6.262-4.959,13.987-4.959C378.25,372.463,384.512,374.683,384.512,377.421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C65B7"
    },
    d: "M509.074,404.554c0,3.5-9.158,6.338-20.454,6.338c-11.296,0-20.454-2.837-20.454-6.338 c0-3.5,9.158-6.338,20.454-6.338C499.917,398.216,509.074,401.054,509.074,404.554z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232228"
    },
    d: "M537.003,257.873c-4.986,1.47-8.303-7.801-4.523-9.654c2.878-1.412,9.613,0.778,9.613,0.778 c10.524-5.535,24.47-11.14,24.47-11.14s7.473-9.849,15.901-17.912c4.908-4.694,10.586-5.466,14.835-5.823 c3.306-0.278,5.846-0.565,5.846-0.565s-5.036,9.553-10.041,15.337c-5.004,5.783-13.57,14.519-18.131,17.14 c-9.707,5.576-30.988,8.486-30.988,8.486S543.399,255.991,537.003,257.873z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 540.56,
    y: 217.982,
    transform: "matrix(0.8716 -0.4903 0.4903 0.8716 -55.8627 314.5307)",
    style: {
      fill: "#EFE5DA"
    },
    width: 63.749,
    height: 91.825
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.538,
    y: 228.04,
    transform: "matrix(0.8716 -0.4903 0.4903 0.8716 -44.4389 303.4841)",
    style: {
      fill: "#E5D8CA"
    },
    width: 53.049,
    height: 17.051
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 540.342,
    y: 253.88,
    transform: "matrix(0.8713 -0.4907 0.4907 0.8713 -51.6977 310.8236)",
    width: 53.049,
    height: 0.23
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 542.95,
    y: 258.517,
    transform: "matrix(0.8712 -0.4909 0.4909 0.8712 -53.6257 312.8324)",
    width: 53.049,
    height: 0.23
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 545.559,
    y: 263.153,
    transform: "matrix(0.8713 -0.4907 0.4907 0.8713 -55.5765 314.5761)",
    width: 53.048,
    height: 0.23
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 548.166,
    y: 267.789,
    transform: "matrix(0.8713 -0.4907 0.4907 0.8713 -57.5159 316.4522)",
    width: 53.049,
    height: 0.231
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 550.774,
    y: 272.426,
    transform: "matrix(0.8713 -0.4907 0.4907 0.8713 -59.4555 318.3284)",
    width: 53.048,
    height: 0.231
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 553.382,
    y: 277.062,
    transform: "matrix(0.8713 -0.4907 0.4907 0.8713 -61.3949 320.2045)",
    width: 53.049,
    height: 0.231
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 560.933,
    y: 290.487,
    transform: "matrix(0.8712 -0.4909 0.4909 0.8712 -67.0033 325.7763)",
    width: 53.049,
    height: 0.231
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 563.542,
    y: 295.123,
    transform: "matrix(0.8713 -0.4907 0.4907 0.8713 -68.9498 327.5132)",
    width: 53.048,
    height: 0.231
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36353A"
    },
    d: "M620.784,361.436c0,0,5.057-78.013,4.548-100.535c-17.832,2.622-30.025-0.235-33.58-1.255 c-2.531,25.311-2.363,99.045-2.363,99.045s2.778,3.716,10.467,1.513c7.786-38.33,5.026-49.47,5.026-49.47l0.97-31.113l1.664-0.031 l0.775,32.058c-2.145,15.41,0.361,38.513,1.85,49.742C612.123,362.35,616.951,364.166,620.784,361.436z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AF6A37"
    },
    d: "M589.389,358.692c0,0-19.706,14.084-18.053,19.082c1.655,4.999,27.029-10.494,27.029-10.494 c0.536-2.457,1.031-4.811,1.491-7.075C592.167,362.408,589.389,358.692,589.389,358.692z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AF6A37"
    },
    d: "M637.876,375.701c-1.157-6.509-17.093-14.265-17.093-14.265c-3.832,2.73-8.661,0.914-10.644-0.044 c0.542,4.085,0.949,6.599,0.949,6.599C614.288,371.631,639.033,382.212,637.876,375.701z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8F8F8"
    },
    d: "M625.367,264.787c0.004-3.472-0.069-6.191-0.242-7.894c-1.483-14.67,2.027-34.968-0.467-39.378 c-2.371-4.194-16.972-4.076-16.972-4.076s-8.755-0.205-13.791,1.799c-1.398,0.557-2.511,1.285-3.067,2.234 c-3.126,5.328,3.386,26.825,1.572,37.151c-0.428,2.436-0.795,6.074-1.111,10.549C595.221,268.72,608.231,278.015,625.367,264.787z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD19F"
    },
    d: "M605.73,221.178c0,0,8.193-5.023,9.892-7.23c-4.074-0.54-7.936-0.509-7.936-0.509 s-2.971-0.069-6.445,0.269C601.413,215.288,605.73,221.178,605.73,221.178z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFB94D"
    },
    d: "M593.107,188.334l19.471,21.578c20.764-2.396,19.68-26.967,18.561-31.69 c-1.332-5.62-6.238-5.14-6.238-5.14s-2.785-6.115-10.72-6.746c-7.935-0.631-25.608,3.336-28.854,10.009 c-3.246,6.672,6.58,8.475,10.459,7.574L593.107,188.334z"
  }), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_80_",
    d: "M602.896,209.724c0,0-8.36-0.57-10.499-8.222c-2.327-8.315-2.209-20.966,3.76-26.478 c5.965-5.512,26.68-6.724,29.044,8.38c2.143,13.666-3.059,22.362-12.624,26.508v4.459c0,0-3.696,5.34-9.755,0.739 L602.896,209.724z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_80_",
    style: {
      overflow: "visible",
      fill: "#FFD19F"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000052061930651537673750000018036262294579655815_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_80_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000052061930651537673750000018036262294579655815_)",
      fill: "#F9B693"
    },
    d: "M615.825,199.485 c0,2.637-2.138,4.776-4.775,4.776c-2.638,0-4.776-2.138-4.776-4.776s2.138-4.775,4.776-4.775 C613.687,194.71,615.825,196.848,615.825,199.485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000052061930651537673750000018036262294579655815_)",
      fill: "#F9B693"
    },
    d: "M597.476,199.008 c0,2.637-2.138,4.776-4.776,4.776c-2.638,0-4.776-2.138-4.776-4.776c0-2.637,2.138-4.776,4.776-4.776 C595.338,194.233,597.476,196.371,597.476,199.008z"
  })), /*#__PURE__*/React.createElement("g", null, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M599.04,200.645c-0.021,0-0.043-0.006-0.061-0.019c-0.166-0.115-0.299-0.331-0.417-0.521 c-0.039-0.064-0.077-0.124-0.112-0.175c-0.28-0.399-0.711-1.219-0.552-1.756c0.05-0.163,0.317-0.298,0.689-0.471 c0.098-0.045,0.19-0.088,0.225-0.112c0.48-0.326,1.147-0.857,1.594-1.538c0.797-1.207,1.198-2.891,1.1-4.621 c-0.109-1.937-1.015-3.868-2.366-5.037c-0.982-0.85-2.145-1.244-3.365-1.138c-0.63,0.055-1.156,0.157-1.674,0.479 c-0.05,0.031-0.117,0.016-0.148-0.035c-0.031-0.05-0.016-0.117,0.035-0.148c0.587-0.364,1.197-0.46,1.77-0.51 c1.279-0.112,2.498,0.3,3.524,1.189c1.393,1.207,2.327,3.195,2.44,5.188c0.101,1.775-0.313,3.507-1.135,4.752 c-0.466,0.709-1.156,1.26-1.653,1.597c-0.049,0.033-0.14,0.076-0.255,0.129c-0.162,0.076-0.542,0.252-0.574,0.339 c-0.136,0.458,0.282,1.228,0.522,1.57c0.038,0.055,0.077,0.118,0.119,0.185c0.107,0.172,0.228,0.367,0.357,0.457 c0.049,0.034,0.061,0.101,0.027,0.15C599.108,200.629,599.074,200.645,599.04,200.645z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M604.599,187.083c-0.027,0-0.054-0.01-0.074-0.03c-0.043-0.041-0.044-0.109-0.003-0.152 c1.768-1.846,4.258-2.496,6.659-1.738c0.58,0.183,1.01,0.536,1.426,0.877c0.224,0.184,0.455,0.373,0.706,0.533 c0.05,0.032,0.065,0.098,0.033,0.148c-0.032,0.05-0.098,0.065-0.148,0.033c-0.262-0.167-0.498-0.36-0.727-0.548 c-0.418-0.343-0.813-0.667-1.354-0.838c-2.322-0.732-4.729-0.104-6.439,1.682C604.655,187.071,604.627,187.083,604.599,187.083z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M603.25,205.346c-0.092,0-0.182-0.003-0.267-0.01c-0.059-0.005-0.104-0.056-0.099-0.115 c0.005-0.059,0.056-0.101,0.115-0.099c0.908,0.069,1.958-0.24,2.554-0.75c0.045-0.038,0.113-0.033,0.152,0.012 c0.039,0.045,0.034,0.113-0.012,0.152C605.026,205.107,604.033,205.346,603.25,205.346z"
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_79_",
    d: "M612.179,193.546c0.942-2.299,0.161-4.741-1.746-5.456c-1.905-0.714-4.216,0.57-5.158,2.869 c-0.942,2.299-0.161,4.741,1.746,5.456C608.926,197.129,611.236,195.845,612.179,193.546z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_79_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000047762614567865276590000015232964435543917464_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_79_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000047762614567865276590000015232964435543917464_)",
      fill: "#51B6BB"
    },
    d: "M610.004,192.947 c-0.038,2.043-1.515,3.673-3.299,3.64c-1.785-0.033-3.201-1.716-3.163-3.759s1.515-3.672,3.299-3.64 C608.626,189.221,610.042,190.904,610.004,192.947z"
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_78_",
    d: "M593.135,192.019c-0.244-2.471,1.11-4.598,3.024-4.752c1.915-0.154,3.665,1.724,3.908,4.195 c0.245,2.47-1.109,4.598-3.024,4.752C595.128,196.367,593.378,194.489,593.135,192.019z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_78_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000120535245722312021830000012926206236136162481_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_78_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000120535245722312021830000012926206236136162481_)",
      fill: "#51B6BB"
    },
    d: "M598.476,192.851 c-0.038,2.043-1.515,3.673-3.299,3.64s-3.201-1.716-3.163-3.759c0.037-2.043,1.515-3.673,3.299-3.64 C597.098,189.125,598.514,190.808,598.476,192.851z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_77_",
    d: "M599.484,201.304c0,0,4.557,1.116,7.326-1.937c0,0-0.024,3.883-2.627,4.598 C600.577,204.957,599.484,201.304,599.484,201.304z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_77_",
    style: {
      overflow: "visible",
      fill: "#421C0D"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000049923349715282341290000012806026219675089843_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_77_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000049923349715282341290000012806026219675089843_)",
      fill: "#ED765F"
    },
    d: "M606.81,199.367 c-1.026,1.131-2.296,1.689-3.49,1.944c-0.39,0.753-0.667,1.723-0.453,2.82c0.396,0.014,0.833-0.033,1.317-0.166 C606.786,203.251,606.81,199.367,606.81,199.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000049923349715282341290000012806026219675089843_)",
      fill: "#FFFFFF"
    },
    d: "M607.05,200.379 c0,0-0.716,0.77-1.849,1.373c-1.611,0.857-3.949,1.068-4.8-0.608l6.65-2.859V200.379z"
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M618.142,198.197c-0.059,0-0.107-0.048-0.107-0.107c0-2.358,1.437-5.6,3.575-6.667c0.053-0.027,0.118-0.005,0.144,0.048 c0.027,0.053,0.005,0.118-0.048,0.144c-2.068,1.031-3.456,4.18-3.456,6.475C618.25,198.148,618.202,198.197,618.142,198.197z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFB94D"
    },
    d: "M613.872,180.713c0.072,6.697,3.363,12.432,3.363,12.432s1.892-4.886,5.207-3.87 c3.319,1.015,2.721,10.825-3.454,12.852l-6.41,7.786c10.902-3.65,15.329-13.131,13.15-27.025 c-2.271-14.51-20.678-14.443-27.892-9.603c-5.351,2.16-6.845,9.002-6.845,9.002s6.641,0.689,10.745-3.292 c0,0-4.479,5.694-0.348,5.736C605.519,184.772,613.872,180.713,613.872,180.713z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD19F"
    },
    d: "M535.041,253.668c1.416,3.52,2.047,6.583-1.869,8.158c-3.916,1.575-5.581-1.07-6.997-4.591 c-1.416-3.521-2.121-6.553,1.869-8.158C532.033,247.472,533.625,250.148,535.041,253.668z"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M525.253,254.586c-0.037,0-0.074-0.019-0.097-0.053c-0.034-0.053-0.02-0.124,0.034-0.159 c1.175-0.764,4.357-2.64,8.512-3.556c0.061-0.015,0.123,0.026,0.137,0.087c0.014,0.062-0.025,0.123-0.088,0.137 c-4.117,0.907-7.27,2.767-8.436,3.524C525.296,254.58,525.274,254.586,525.253,254.586z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M526.175,257.351c-0.037,0-0.074-0.019-0.097-0.053c-0.034-0.053-0.02-0.124,0.034-0.159 c1.305-0.848,4.844-2.689,8.904-3.583c0.059-0.017,0.123,0.026,0.137,0.088c0.014,0.061-0.025,0.123-0.088,0.137 c-4.027,0.888-7.536,2.711-8.828,3.552C526.218,257.345,526.196,257.351,526.175,257.351z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M527.398,259.886c-0.037,0-0.074-0.019-0.097-0.053c-0.034-0.053-0.019-0.124,0.034-0.159 c1.176-0.765,4.36-2.641,8.511-3.555c0.063-0.015,0.123,0.026,0.137,0.088c0.014,0.062-0.025,0.123-0.088,0.137 c-4.113,0.906-7.268,2.766-8.434,3.523C527.44,259.88,527.419,259.886,527.398,259.886z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232228"
    },
    d: "M625.364,263.332c-0.001-0.179-0.003-0.352-0.004-0.527c-0.002-0.221-0.004-0.441-0.007-0.654 c-0.002-0.17-0.005-0.333-0.008-0.498c-0.003-0.205-0.007-0.41-0.011-0.607c-0.001-0.049-0.003-0.095-0.004-0.144 c-0.037-1.648-0.104-3.008-0.205-4.008c-1.483-14.67,2.027-34.968-0.467-39.378c-1.238-2.191-5.813-3.204-9.902-3.673 c-1.275,2.59-3.574,8.805-4.181,20.791c-0.439,8.665-0.371,19.199,1.906,27.327c0.878,3.133,2.083,5.908,3.717,8.078 c2.171,2.884,5.098,4.695,9.007,4.87c0.1-3.802,0.157-7.222,0.161-10.12c0-0.063,0-0.128,0-0.19c0-0.198,0-0.39-0.001-0.583 C625.365,263.785,625.365,263.555,625.364,263.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232228"
    },
    d: "M600.226,213.82c-2.204,0.261-4.967,0.372-6.787,1.096c-1.398,0.557-2.729,1.779-3.285,2.728 c-3.126,5.328,4.061,26.654,2.247,36.98c-0.234,1.331-0.449,3.033-0.648,5.023c-0.014,0.14-0.028,0.28-0.042,0.423 c-0.021,0.218-0.042,0.436-0.063,0.661c-0.021,0.224-0.041,0.456-0.061,0.686c-0.021,0.232-0.041,0.46-0.061,0.698 c-0.022,0.26-0.043,0.531-0.064,0.798c-0.033,0.414-0.066,0.836-0.098,1.267c-0.021,0.278-0.042,0.553-0.062,0.838 c-0.004,0.051-0.007,0.105-0.011,0.156c-0.204,2.891-0.386,6.129-0.549,9.621c1.429-0.306,4.821-1.424,7.106-5.31 c1.147-1.951,2.012-4.6,2.208-8.197c0.075-1.387,0.054-2.91-0.092-4.593C598.758,242.839,599.774,221.695,600.226,213.82z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD19F"
    },
    d: "M627.938,288.901c-1.364,5.016-5.659,11.544-8.731,10.456c-2.533-0.895-3.263-5.44-2.857-9.631 c0.308-3.191,2.389-6.36,2.389-6.36s-6.241,3.567-5.276,0.245c0.965-3.323,9.955-7.52,9.955-7.52 c0.81-11.863,3.354-26.677,3.354-26.677s-4.465-11.529-6.907-22.935c-2.526-11.809,0.537-11.563,0.537-11.563 s7.434,0.943,9.732,8.238c2.298,7.294,5.826,22.949,5.665,28.206c-0.345,11.19-6.687,26.015-6.687,26.015 S629.691,282.468,627.938,288.901z"
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M617.125,297.052c-0.021,0.009-0.045,0.011-0.069,0.005c-0.057-0.015-0.092-0.074-0.076-0.131 c0.022-0.082,2.388-7.757,2.886-8.891c-0.003-0.016-0.003-0.033,0.001-0.05l0.02,0.004c0.027-0.058,0.049-0.09,0.059-0.092 c0.037-0.01,0.077,0.001,0.104,0.028c0.027,0.027,0.035,0.08,0.025,0.117c-0.003,0.013-0.009,0.024-0.016,0.034 c-0.18,0.483-2.3,6.749-2.871,8.906C617.179,297.014,617.155,297.039,617.125,297.052z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.123,299.366c-0.021,0.009-0.045,0.011-0.069,0.005c-0.057-0.015-0.092-0.074-0.076-0.132 c0.324-1.223,0.917-3.021,1.544-4.923c0.657-1.992,1.336-4.052,1.705-5.463c0.015-0.058,0.074-0.092,0.131-0.077 c0.057,0.015,0.092,0.074,0.077,0.131c-0.37,1.418-1.051,3.481-1.709,5.477c-0.626,1.9-1.218,3.694-1.541,4.911 C619.176,299.328,619.153,299.354,619.123,299.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.425,299.137c-0.026,0.011-0.056,0.012-0.083,0c-0.055-0.023-0.08-0.086-0.057-0.141 c1.022-2.439,1.93-5.492,3.062-9.627c0.016-0.057,0.075-0.091,0.132-0.075c0.057,0.016,0.091,0.075,0.075,0.132 c-1.135,4.144-2.044,7.204-3.071,9.654C621.471,299.106,621.45,299.126,621.425,299.137z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232228"
    },
    d: "M630.134,223.154c-2.298-7.295-9.732-8.238-9.732-8.238s-4.063-0.048-1.536,11.76 c2.442,11.406,7.906,22.738,7.906,22.738s-2.544,14.814-3.354,26.677c0,0,2.241-0.246,5.695,1.285c0,0,6.341-14.826,6.687-26.015 C635.96,246.103,632.432,230.448,630.134,223.154z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateJobGroups);
export default __webpack_public_path__ + "static/media/Create-job-groups.3ae11ba9.svg";
export { ForwardRef as ReactComponent };